
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as jobsQ5jx5RDqIsXsdaZkTrmogAtMv_45fWTg2qh8fk5HtpvPYMeta } from "/vercel/path0/pages/jobs.vue?macro=true";
import { default as team6aovK0Nts91CyC2cJBQ8zGWUTa1XBePmnYwjh0dXPukMeta } from "/vercel/path0/pages/team.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as historyk1QCqN90eS3oVOTuQFyPGfTKN0h0Ny_45gnm2dHLVUmQIMeta } from "/vercel/path0/pages/history.vue?macro=true";
import { default as myfisco10gznW13_8MRjplbHLOe7i59DZq_45nDXPaNeXjTrSrygMeta } from "/vercel/path0/pages/myfisco.vue?macro=true";
import { default as articleskv0jbK_45mfeOLPQ0oPeetmbp9aUDzy9iCI1CrqstKJg8Meta } from "/vercel/path0/pages/articles.vue?macro=true";
import { default as servicesj2jF3hIv2H0UdDNfbhNWYbUZYLNGO8_45K_9oaxB_45rgdYMeta } from "/vercel/path0/pages/services.vue?macro=true";
import { default as testimonialsedwJeJJZcCD9AjfyPYW0Shl9RSmq0iEXVW1jpZ2NtgwMeta } from "/vercel/path0/pages/testimonials.vue?macro=true";
import { default as _91slug_93fSFK84lKE_45tut3tMC5M9KJ38wpDlhP0EHplJR7l1WBIMeta } from "/vercel/path0/pages/particle/[slug].vue?macro=true";
export default [
  {
    name: "jobs___fr",
    path: "/emplois",
    component: () => import("/vercel/path0/pages/jobs.vue")
  },
  {
    name: "jobs___de",
    path: "/de/jobs",
    component: () => import("/vercel/path0/pages/jobs.vue")
  },
  {
    name: "team___fr",
    path: "/equipe",
    component: () => import("/vercel/path0/pages/team.vue")
  },
  {
    name: "team___de",
    path: "/de/team",
    component: () => import("/vercel/path0/pages/team.vue")
  },
  {
    name: "index___fr",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "contact___fr",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/kontakt",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "history___fr",
    path: "/a-propos",
    component: () => import("/vercel/path0/pages/history.vue")
  },
  {
    name: "history___de",
    path: "/de/ueber-uns",
    component: () => import("/vercel/path0/pages/history.vue")
  },
  {
    name: "myfisco___fr",
    path: "/myfisco",
    component: () => import("/vercel/path0/pages/myfisco.vue")
  },
  {
    name: "myfisco___de",
    path: "/de/myfisco",
    component: () => import("/vercel/path0/pages/myfisco.vue")
  },
  {
    name: "articles___fr",
    path: "/articles",
    component: () => import("/vercel/path0/pages/articles.vue")
  },
  {
    name: "articles___de",
    path: "/de/alle-artikel",
    component: () => import("/vercel/path0/pages/articles.vue")
  },
  {
    name: "services___fr",
    path: "/services",
    component: () => import("/vercel/path0/pages/services.vue")
  },
  {
    name: "services___de",
    path: "/de/dienstleistungen",
    component: () => import("/vercel/path0/pages/services.vue")
  },
  {
    name: "testimonials___fr",
    path: "/temoignages",
    component: () => import("/vercel/path0/pages/testimonials.vue")
  },
  {
    name: "testimonials___de",
    path: "/de/erfahrungsberichte",
    component: () => import("/vercel/path0/pages/testimonials.vue")
  },
  {
    name: "particle-slug___fr",
    path: "/article/:slug()",
    component: () => import("/vercel/path0/pages/particle/[slug].vue")
  },
  {
    name: "particle-slug___de",
    path: "/de/artikel/:slug()",
    component: () => import("/vercel/path0/pages/particle/[slug].vue")
  }
]